import React from 'react'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import { InputBase, withStyles, Button } from '@material-ui/core'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import { create, list } from 'actions/data'
import shortener_urls from 'utils/ShortenerUrl'
import { themeObj } from 'components/withRoot'
import copy from 'copy-to-clipboard'
import { openSnackbar } from 'actions/view'

export default withRouter(
  connect(
    (state, { match }) => ({}),
    dispatch =>
      bindActionCreators(
        {
          create,
          list,
          openSnackbar,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        // ...other styles for the pages
        content: {
          padding: 24,
          [theme.breakpoints.down('sm')]: {
            // padding: maybe something else for 'sm' size,
          },
          [theme.breakpoints.down('xs')]: {
            padding: 0,
          },
        },
      }))(
        class AddOrEditURL extends React.Component {
          constructor(props) {
            super(props)

            this.state = {
              long_url: '',
              loading: false,
            }
          }

          componentDidMount() {}
          showUrlModal = show => {
            this.setState({
              ...this.state,
              showUrlModal: show,
              loading: false,
            })
          }
          createURL() {
            const { long_url } = this.state
            const { create } = this.props
            const that = this
            this.setState({
              ...this.state,
              loading: true,
            })
            if (long_url.length > 0) {
              create({
                entity: {
                  long_url,
                },
                entityType: 'url',
                path: null,
                noReturnValue: false,
                hasSchema: false,
                url: shortener_urls.api_url,
              }).then(payload => {
                console.log('record', payload)
                copy(shortener_urls.public_url + '/' + payload.url_code)
                this.props.openSnackbar({
                  type: 'success',
                  message: 'Your url was successfully copied to clipboard',
                })
                that.showUrlModal(false)
              })
            }
          }
          onLongURLKeyUp = event => {
            this.setState({
              ...this.state,
              long_url: event.target.value,
            })
            if (event.keyCode === 13) {
              this.createURL()
            }
          }
          clickCreatelong_urlButton = () => {
            this.createURL()
          }
          render() {
            const { loading } = this.state
            const { open, onClose } = this.props

            return (
              <div>
                {loading ? (
                  <div>Generating Short URL</div>
                ) : (
                  <Dialog
                    open={open}
                    onClose={onClose}
                    aria-labelledby="responsive-dialog-title"
                    style={{ borderRadius: 22 }}
                    maxWidth="xl"
                  >
                    <DialogContent>
                      <div style={{ minWidth: 500 }}>
                        <h2>Enter a URL to shorten</h2>
                        <InputBase
                          autoFocus
                          autoComplete={'off'}
                          onKeyUp={this.onLongURLKeyUp}
                          style={{
                            fontSize: 20,
                            color: themeObj.palette.black,
                            fontWeight: 'normal',
                            width: '90%',
                          }}
                          placeholder="Enter a long URL that will be shortened"
                          id="input-with-icon-textfield"
                        />
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={onClose}
                        color="secondary"
                      >
                        close
                      </Button>
                      {this.state.long_url.trim().length > 0 ? (
                        <Button
                          onClick={this.clickCreatelong_urlButton}
                          style={{
                            backgroundColor: themeObj.palette.green,
                            color: 'white',
                          }}
                        >
                          Shorten URL
                        </Button>
                      ) : null}
                    </DialogActions>
                  </Dialog>
                )}
              </div>
            )
          }
        },
      ),
    ),
  ),
)
